import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Promo from '@/views/Promo.vue';
import PromoDetail from '@/views/PromoDetail.vue';
import Contact from '@/views/Contact.vue';
import Category from '@/views/Category.vue';
import Product from '@/views/Product.vue';

Vue.use(VueRouter);

const Route = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                title: ''
            },
        },
        {
            path: '/promo',
            name: 'Promo',
            component: Promo,
            meta: {
                title: 'Promo'
            },
        },
        {
            path: '/promo/:id',
            name: 'Promo Detail',
            component: PromoDetail,
            props: true,
            meta: {
                title: 'Promo Detail'
            },
        },
        {
            path: '/contact-us',
            name: 'Contact Us',
            component: Contact,
            meta: {
                title: ''
            },
        },
        {
            path: '/category/:id',
            name: 'Category',
            component: Category,
            props: true,
            meta: {
                title: 'Category'
            },
        },
        {
            path: '/product/:id',
            name: 'Product',
            component: Product,
            props: true,
            meta: {
                title: 'Product'
            },
        },
        {
            path: '*',
            redirect: '/'
        },
    ],
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
});

Route.beforeEach((to, _from, next) => {
    if(to.meta.title !== '') {
        document.title = 'Motto Yakiniku | '+to.meta.title;
    } else {
        document.title = 'Motto Yakiniku';
    }

    next();
});

export default Route;
